import { render, staticRenderFns } from "./AccountTypeSelector.vue?vue&type=template&id=100bfa93&scoped=true&"
import script from "./AccountTypeSelector.vue?vue&type=script&lang=js&"
export * from "./AccountTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bfa93",
  null
  
)

export default component.exports